import { render, staticRenderFns } from "./MpPay.vue?vue&type=template&id=88f23cd0&"
import script from "./MpPay.vue?vue&type=script&lang=js&"
export * from "./MpPay.vue?vue&type=script&lang=js&"
import style0 from "./MpPay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports